import * as React from 'react';

import Notification from 'bundles/course-cards/components/common/Notification';
import { useModalManager } from 'bundles/page-config-common/contexts/consumer/ModalManagerContext';
import { useBffEnrolledProducts } from 'bundles/unified-home-common/contexts/consumer/BffEnrolledProductsContext';

const ConsumerNotificationsNotConfigurable = () => {
  const { currentActionNotificationTypeName, isNotificationVisible, modifiedProductModalData } = useModalManager();
  const { enrolledProducts } = useBffEnrolledProducts();

  if (!modifiedProductModalData || !enrolledProducts) {
    return null;
  }

  const modifiedCourseId = modifiedProductModalData.courseId;
  const enrolledCourseDataFromModifiedId = enrolledProducts.find(
    (course) => course.learningProduct.id === modifiedCourseId
  );

  if (!enrolledCourseDataFromModifiedId) {
    return null;
  }

  return (
    <div>
      <Notification
        messageTypeName={currentActionNotificationTypeName}
        isNotificationVisible={isNotificationVisible}
        courseName={enrolledCourseDataFromModifiedId?.learningProduct.name ?? ''}
        courseSlug={enrolledCourseDataFromModifiedId?.learningProduct.slug ?? ''}
        courseId={enrolledCourseDataFromModifiedId?.learningProduct.id ?? ''}
        isRhymeProject={
          enrolledCourseDataFromModifiedId?.learningProduct.courseTypeMetadata.metadata.__typename ===
          'Course_RhymeProjectMetadata'
        }
      />
    </div>
  );
};

export default ConsumerNotificationsNotConfigurable;
